import { makeStyles } from '@mui/styles';
import { Colors, Breakpoints } from '../../../../assets/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles<Theme>((theme) => ({
  input: {
    padding: 0,
    height: '100%',
    '&::placeholder': {
      color: Colors.Gray,
    },
  },
  container: {
    width: '500px',
    // [theme.breakpoints.down(Breakpoints.XS)]: {
    //   width: 'auto',
    // },
  },
}));

export default useStyles;